<template lang="pug">
  b-modal(ref="bulkAssignPartnerModal" title="Asignar Partner" hide-footer size="md" @hidden="clear" no-close-on-backdrop)
    b-form(@submit.stop.prevent="onSubmit")
      .mb-3(v-if="errorDetail")
        b-alert(show variant="danger") {{ errorDetail }}
      .mb-3
        p.font-weight-bold {{ selectedIds.length }} envíos seleccionados
      b-form-group(label="Partner" invalid-feedback="Debe seleccionar un partner" :state="partnerState")
        v-select(
          v-model="form.partnerCode"
          :options="partnerOptions"
          label="text"
          :reduce="option => option.value"
          placeholder="Selecciona un partner"
        )
      hr
      .text-right
        b-button(variant="outline-primary" @click="close" class="mr-2") Cancelar
        b-button(type="submit" variant="secondary" :disabled="loading || form.partnerCode === null")
          .d-flex.align-items-center
            b-spinner(v-if="loading" small class="mr-1")
            | Asignar Partner
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import partnerUtils from '@/utils/partnerUtils'

export default {
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      errorDetail: null,
      selectedIds: [],
      form: {
        partnerCode: null
      }
    }
  },
  computed: {
    ...mapGetters(['deliveries']),
    partnerOptions () {
      return [
        ...partnerUtils.partnerSelectOptions,
        { text: 'Sin Partner (desasignar)', value: '__none__' }
      ]
    },
    selectedPartnerLabel () {
      const option = this.partnerOptions.find(o => o.value === this.form.partnerCode)
      return option ? option.text : this.form.partnerCode
    },
    partnerState () {
      return this.form.partnerCode !== null && this.form.partnerCode !== '' ? true : null
    }
  },
  methods: {
    ...mapActions(['bulkSetPartnerByIds']),
    show (ids = []) {
      this.selectedIds = [...ids]
      this.form.partnerCode = null
      this.errorDetail = null
      this.loading = false
      this.$refs.bulkAssignPartnerModal.show()
    },
    clear () {
      this.selectedIds = []
      this.form.partnerCode = null
      this.errorDetail = null
      this.loading = false
    },
    close () {
      this.$refs.bulkAssignPartnerModal.hide()
    },
    async onSubmit () {
      if (this.form.partnerCode === null) return

      const ok = await this.$bvModal.msgBoxConfirm(
        `¿Estás seguro de asignar el partner "${this.selectedPartnerLabel}" a ${this.selectedIds.length} envíos?`,
        {
          title: 'Confirmar asignación',
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }
      )
      if (!ok) return

      this.loading = true
      this.errorDetail = null
      try {
        const partnerCode = this.form.partnerCode === '__none__' ? null : this.form.partnerCode
        const response = await this.bulkSetPartnerByIds({
          data: { deliveryIds: this.selectedIds, partnerCode }
        })

        if (response.status >= 200 && response.status < 300) {
          this.$root.$bvToast.toast(response.data.message || 'Envíos actualizados correctamente', {
            title: 'Éxito',
            variant: 'success'
          })
          this.$emit('done')
          this.close()
        } else if (response.status >= 400) {
          const message = response.data?.message || 'Error al asignar partner'
          this.$root.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger'
          })
          if (response.data?.detail) {
            this.errorDetail = response.data.detail
          }
        }
      } catch (error) {
        console.error(error)
        this.errorDetail = error?.response?.data?.detail || error?.message || 'Error inesperado'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
